var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 375,
    viewBox: "0 0 284 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46571",
    "data-name": "Group 46571",
    transform: "translate(11131 -18582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46569",
    "data-name": "Group 46569",
    transform: "translate(2757 27842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17255",
    "data-name": "Rectangle 17255",
    width: 284,
    height: 375,
    transform: "translate(-13888 -9260)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_95_3",
    "data-name": "Component 95 \\u2013 3",
    transform: "translate(-13782 -9108)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45091",
    "data-name": "Group 45091",
    transform: "translate(-981.01 -372.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76034",
    "data-name": "Path 76034",
    d: "M83.966,56.9,30.4,64.14a1.426,1.426,0,0,1-1.6-1.222L21.561,9.358a1.426,1.426,0,0,1,1.222-1.6L76.343.513a1.426,1.426,0,0,1,1.6,1.223L85.187,55.3A1.425,1.425,0,0,1,83.966,56.9Z",
    transform: "translate(959.465 372.292)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76035",
    "data-name": "Path 76035",
    d: "M83.755,56.914,31.618,63.962a1.462,1.462,0,0,1-1.645-1.253L22.924,10.57a1.463,1.463,0,0,1,1.254-1.645L76.315,1.878A1.463,1.463,0,0,1,77.96,3.132l7.048,52.137a1.461,1.461,0,0,1-1.253,1.645",
    transform: "translate(958.1 370.927)",
    fill: "#5d5d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76036",
    "data-name": "Path 76036",
    d: "M87.234,69.428,33.309,65.792a1.426,1.426,0,0,1-1.327-1.519l3.636-53.925A1.426,1.426,0,0,1,37.136,9.02l53.926,3.636a1.427,1.427,0,0,1,1.327,1.519L88.754,68.1a1.426,1.426,0,0,1-1.519,1.327",
    transform: "translate(960.834 373.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76037",
    "data-name": "Path 76037",
    d: "M87.234,69.428,33.309,65.792a1.426,1.426,0,0,1-1.327-1.519l3.636-53.925A1.426,1.426,0,0,1,37.136,9.02l53.926,3.636a1.427,1.427,0,0,1,1.327,1.519L88.754,68.1A1.426,1.426,0,0,1,87.234,69.428Z",
    transform: "translate(960.834 373.41)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76038",
    "data-name": "Path 76038",
    d: "M82.6,56.49,38.952,53.548a1.428,1.428,0,0,1-1.327-1.519l2.507-37.18a1.426,1.426,0,0,1,1.519-1.327l43.643,2.942a1.428,1.428,0,0,1,1.327,1.519l-2.507,37.18A1.426,1.426,0,0,1,82.6,56.49",
    transform: "translate(961.575 374.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76039",
    "data-name": "Path 76039",
    d: "M82.6,56.49,38.952,53.548a1.428,1.428,0,0,1-1.327-1.519l2.507-37.18a1.426,1.426,0,0,1,1.519-1.327l43.643,2.942a1.428,1.428,0,0,1,1.327,1.519l-2.507,37.18A1.426,1.426,0,0,1,82.6,56.49Z",
    transform: "translate(961.575 374.001)",
    fill: "none",
    stroke: "#898997",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76040",
    "data-name": "Path 76040",
    d: "M53.159,24.91a4.657,4.657,0,1,1-4.334-4.961,4.657,4.657,0,0,1,4.334,4.961",
    transform: "translate(962.393 374.843)",
    fill: "#888892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76042",
    "data-name": "Path 76042",
    d: "M80.564,50.323,72.546,29.612a1.3,1.3,0,0,0-2.015-.385L60.243,38.215a1.832,1.832,0,0,1-2.584-.174l-3.313-3.793a1.833,1.833,0,0,0-2.609-.153L42.013,47.687c-.1.092.009-.137,0,0a.527.527,0,0,0,.491.562l37.9,2.48C80.7,50.748,80.609,50.41,80.564,50.323Z",
    transform: "translate(962.151 376.02)",
    fill: "#888892"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_3",
    "data-name": "Exclusion 3",
    d: "M55.354,60.413c-.031,0-.061,0-.093,0L1.331,56.774A1.426,1.426,0,0,1,0,55.255L3.64,1.33A1.43,1.43,0,0,1,5.061,0c.032,0,.065,0,.1,0L59.084,3.639a1.428,1.428,0,0,1,1.327,1.519L56.775,59.083A1.429,1.429,0,0,1,55.354,60.413ZM10.317,4.341a2.181,2.181,0,0,0-2.17,2.03L5.639,43.551a2.181,2.181,0,0,0,2.025,2.317l43.643,2.942c.049,0,.1.005.148.005a2.183,2.183,0,0,0,2.17-2.03L56.132,9.6a2.18,2.18,0,0,0-2.024-2.317L10.465,4.345C10.41,4.342,10.364,4.341,10.317,4.341ZM51.456,47.316l-.048,0L7.765,44.372a.679.679,0,0,1-.629-.721L9.644,6.471a.677.677,0,0,1,.673-.631l.039,0L54.006,8.784a.678.678,0,0,1,.629.721l-2.507,37.18A.678.678,0,0,1,51.456,47.316Zm-40.1-6.036v0a.528.528,0,0,0,.491.559l37.9,2.479h.023a.166.166,0,0,0,.153-.073.413.413,0,0,0-.021-.334L41.885,23.2a1.3,1.3,0,0,0-2.015-.384L29.582,31.807A1.833,1.833,0,0,1,27,31.633L23.685,27.84a1.833,1.833,0,0,0-2.609-.153L11.352,41.279c0-.024,0-.037-.005-.042s0,0,0,0-.022.017-.028.033-.008.024,0,.031a.006.006,0,0,0,.005,0,.065.065,0,0,0,.034-.02Zm6.736-28.925a4.658,4.658,0,0,0-.31,9.3c.106.007.213.011.319.011a4.658,4.658,0,0,0,.308-9.305C18.3,12.358,18.193,12.354,18.088,12.354Z",
    transform: "translate(-11013.198 18743.793)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder-image.94f4ba418f0c2dea532ed0af4f90bc4e.svg";
export { ForwardRef as ReactComponent };